import { Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'ef-theme-toggle',
    templateUrl: './theme-toggle.component.html',
    styleUrls: ['./theme-toggle.component.scss'],
    standalone: false
})
export class ThemeToggleComponent implements OnInit {

    isLightTheme: boolean;
    isDarkTheme: boolean;
  constructor() { }

  ngOnInit() {
  }

  // onSetTheme(e: MatSlideToggleChange, theme: string) {

  //   // if (theme == "dark") {
  //   //   document.getElementById('themeTag').classList.add('dark-theme');
  //   //   document.getElementById('themeTag').classList.remove('light-theme');
  //   //   document.getElementById('themeTag').classList.remove('default-theme');
  //   // }

  //   // if (theme == "light") {
  //   //   document.getElementById('themeTag').classList.add('light-theme');
  //   //   document.getElementById('themeTag').classList.remove('dark-theme');
  //   //   document.getElementById('themeTag').classList.remove('default-theme');
  //   // }

  //   // if (theme == "default") {
  //   //   document.getElementById('themeTag').classList.add('default-theme');
  //   //   document.getElementById('themeTag').classList.remove('light-theme');
  //   //   document.getElementById('themeTag').classList.remove('dark-theme');
  //   // }

  //   theme = null;
  // }

  onSetTheme(e: MatSlideToggleChange) {

    if (e.checked == true) {
      document.getElementById('themeTag').classList.add('dark-theme');
      document.getElementById('themeTag').classList.remove('default-theme');
    } else {
      document.getElementById('themeTag').classList.add('default-theme');
      document.getElementById('themeTag').classList.remove('dark-theme');
    }
    // if (theme == "dark") {
    //   document.getElementById('themeTag').classList.add('dark-theme');
    //   document.getElementById('themeTag').classList.remove('light-theme');
    //   document.getElementById('themeTag').classList.remove('default-theme');
    // }

    // if (theme == "light") {
    //   document.getElementById('themeTag').classList.add('light-theme');
    //   document.getElementById('themeTag').classList.remove('dark-theme');
    //   document.getElementById('themeTag').classList.remove('default-theme');
    // }

    // if (theme == "default") {
    //   document.getElementById('themeTag').classList.add('default-theme');
    //   document.getElementById('themeTag').classList.remove('light-theme');
    //   document.getElementById('themeTag').classList.remove('dark-theme');
    // }
  }
}
